import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import InstructionVideoFormContainer from './InstructionVideoFormContainer';
import InstructionVideoUploadDialogContainer from './InstructionVideoUploadDialogContainer';

const InstructionVideoFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Instruction Videos',
          link: '/instruction-videos',
        },
        {
          text: props.params.instructionVideoId ? 'Edit Instruction Video' : 'Add Instruction Video',
        },
      ]}
    />
    <>
      <InstructionVideoFormContainer instructionVideoId={props.params.instructionVideoId} />
      {props.params.instructionVideoId && <InstructionVideoUploadDialogContainer />}
    </>
  </div>
);

InstructionVideoFormScene.propTypes = {
  params: PropTypes.shape({
    instructionVideoId: PropTypes.string,
  }),
};

InstructionVideoFormScene.defaultProps = {
  params: null,
};

export default InstructionVideoFormScene;
